import { render, staticRenderFns } from "./GTAdvisory.vue?vue&type=template&id=08909db2&scoped=true&"
import script from "./GTAdvisory.vue?vue&type=script&lang=ts&"
export * from "./GTAdvisory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08909db2",
  null
  
)

export default component.exports